export enum WebGLErrorEnum {
  Error = 1,
  ModernizerNoWebGL = 2,
  WebGLNotSupported = 3,
  ShaderCompilationFailure = 4,
  ShaderLinkFailure = 5,
  OutOfVRAM = 6,
  WebGLContentLost = 7
}
